import React, { memo } from "react"
import PropTypes from "prop-types"
import moment from "moment"
import Journal from "pagesV2/pro/Calendar/Modals/Journal"
import styles from "./index.module.css"
import ReservationDetailModal from "pagesV2/pro/Bookings/ReservationDetailPage/ReservationDetailModal"
import { useDayCell } from "./hooks/useDayCell"

const DayCell = ({ day, monthStartDate, monthEndDate, onChangeFilters, timeOffRanges = [], allDayTimeOff = false, thisMonth = true, hideBookings = false, blackout = null, spanLanes, laneCount = 0, alertSlots = [], onOpenDayPanel }) => {
  const {
    content,
    isJournalModalOpen,
    isBookingModalOpen,
    selectedDate,
    selectedBookingId,
    handleCancel,
    handleBookingCancelSuccess,
    isPastDay,
    setJournalOpen
  } = useDayCell({ day, timeOffRanges, allDayTimeOff, onChangeFilters, hideBookings, blackout, spanLanes, laneCount, alertSlots, onOpenDayPanel })

  const classes = ["d-flex flex-column"]

  return (
    <>
      <div
        className={
          `${classes.join(" ")} ${styles.showOnHover} ${styles.dayCellContainer} ` +
          (thisMonth ? "" : styles.notCurrentMonthDay + " ") +
          (allDayTimeOff ? styles.dayCellAllDay + " " : "")
        }
        aria-disabled={isPastDay}
      >
        {content}
      </div>
      {isJournalModalOpen && (
        <Journal
          open={isJournalModalOpen}
          setOpen={setJournalOpen}
          onCancel={handleCancel}
          selectedDate={selectedDate}
          startDate={monthStartDate}
          endDate={monthEndDate}
        />
      )}
      {isBookingModalOpen && (
        <ReservationDetailModal open={isBookingModalOpen} bookingUuid={selectedBookingId} onClose={handleBookingCancelSuccess} />
      )}
    </>
  )
}

DayCell.propTypes = {
  day: PropTypes.instanceOf(moment).isRequired,
  monthStartDate: PropTypes.instanceOf(moment),
  monthEndDate: PropTypes.instanceOf(moment),
  onChangeFilters: PropTypes.func.isRequired,
  timeOffRanges: PropTypes.arrayOf(PropTypes.string),
  allDayTimeOff: PropTypes.bool,
  thisMonth: PropTypes.bool,
  hideBookings: PropTypes.bool,
  /** The day's entry from the blackout feed, or null when the day is clear. */
  blackout: PropTypes.shape({
    status: PropTypes.string,
    bookings_requiring_action: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    blackouts: PropTypes.array
  }),
  /** This day's lane of multi-day bars, from `buildBookingSpans`. A `span` of 0 is a pass-over. */
  spanLanes: PropTypes.arrayOf(PropTypes.shape({ booking: PropTypes.object, span: PropTypes.number })),
  /** Lanes reserved across the whole week, so every cell in the row starts its tiles level. */
  laneCount: PropTypes.number,
  /** Alert rows reserved across the whole week, from `buildDayAlertSlots`. Empty rows here are
   *  what keeps a bar reaching in from the left clear of another day's alert. */
  alertSlots: PropTypes.arrayOf(PropTypes.string),
  onOpenDayPanel: PropTypes.func,
}

DayCell.defaultProps = {
  monthStartDate: moment(),
  monthEndDate: moment(),
  timeOffRanges: [],
  allDayTimeOff: false,
  thisMonth: true
}

export default memo(DayCell)
